import axios from 'axios';
import environment from 'environments/environment';

const CubeServiceAxios = axios.create({
  baseURL: `${environment.CUBE_URL}`,
});

export default CubeServiceAxios;
